export default {
  error_add_identifier: "There was an error adding an identifier",
  error_adding_attachment:
    "An error occurred while adding an attachment. We are already handling it.",
  error_adding_comment: "An error occurred while adding the comment. We are already handling it.",
  error_adding_image: "An error occurred while adding the image. We are already handling it.",
  error_change_password:
    "An error occurred while changing the password. We are already handling it.",
  error_change_unlock_key:
    "An error occurred while changing the unlock key. We are already handling it.",
  error_creating_corrective_action:
    "There was a problem while creating the corrective action. We're already handling it.",
  error_creating_corrective_work:
    "There was a problem while creating the corrective work. We are already handling it.",
  error_creating_issue: "There was a problem while creating the issue. We're already handling it.",
  error_creating_regular_work:
    "There was a problem while creating the regular work. We are already handling it.",
  error_creating_corrective_work_order:
    "There was a problem while creating the corrective work order. We are already handling it.",
  error_creating_regular_work_order:
    "There was a problem while creating the regular work order. We are already handling it.",
  error_updating_corrective_work_order:
    "There was a problem while updating the corrective work order. We are already handling it.",
  error_updating_regular_work_order:
    "There was a problem while updating the regular work order. We are already handling it.",
  error_updating_issue_on_item:
    "An error occurred while updating the issue on item. We are already handling it.",
  error_deleting_attachment:
    "An error occurred while deleting an attachment. We are already handling it.",
  error_deleting_attachment_with_name:
    "An error occurred while deleting {fileName}. We are already handling it.",
  error_deleting_attachment_with_count:
    "Failed to delete {failedCount} out of {totalCount} attachments. We are already handling it.",
  error_disassociate_identifiers: "There was an error disassociating identifiers",
  error_closing_issue: "An error occurred while closing the issue. We are already handling it.",
  error_closing_issues:
    "An error occurred while trying to close the issues raised on this Regular Work. We are already handling it.",
  error_closing_work_order_corrective:
    "An error occurred while closing the corrective work order. We are already handling it.",
  error_closing_work_order_regular:
    "An error occurred while closing the regular work order. We are already handling it.",
  error_modifying_work_order:
    "An error occurred while modifying the work order. We are already handling it.",
  error_accepting_corrective_work:
    "An error occurred while accepting the corrective work. We are already handling it.",
  error_accepting_regular_work:
    "An error occurred while accepting the regular work. We are already handling it.",
  error_rejecting_corrective_work:
    "An error occurred while rejecting the corrective work. We are already handling it.",
  error_rejecting_regular_work:
    "An error occurred while rejecting the regular work. We are already handling it.",
  error_rejecting_issue: "An error occurred while rejecting the issue. We are already handling it.",
  error_updating_attachment:
    "An error occurred while updating an attachment. We are already handling it.",
  error_updating_attributes:
    "There was an error trying to update some of the attributes for this item",
  error_updating_corrective_action:
    "An error occurred while updating corrective action(s). We are already handling it.",
  error_updating_item: "There was an error trying to update the item",
  error_updating_issue: "There was an error trying to update the issue",
  error_no_valid_work_domains: "There are no valid work domains available to choose from.",
  error_deadline_after_start_date: "Deadline cannot be before or equal to the start date time",
  error_range_end_after_range_start:
    "Range end cannot be before or equal to the range start date time",
  error_failed_to_send_email: "Failed to send an email.",
  error_proof_of_presence_required: "Proof of presence is required.",
  error_work_order_extract: "An error occurred while handling work order data.",
}
